module.exports = __webpack_public_path__ + "img/9788958287636.0ccde1c9.jpg";